import React from "react";
import styled from "styled-components";

import { useStore } from 'react-context-hook';


const ControlWrapper = styled.div`
    position: fixed;
    height: 200px;
    width: 200px;
    top: 0;
    right: 0;
`;

const ScoreWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 20px;
`;


const ScoreBoard = () => {

    const [points] = useStore('points', [0, 0, 0, 0]);


    const [player] = useStore('player', 0);

    const yourScore = points[player];
    const otherScore = points[(player + 1) % 4];
    return (
        <ControlWrapper>
            Your Team
            <ScoreWrapper>
                {yourScore}
            </ScoreWrapper>
            Other Team
            <ScoreWrapper>
                {otherScore}
            </ScoreWrapper>
        </ControlWrapper>
    );
};

export default ScoreBoard;